module.exports = __webpack_public_path__ + "static/img/home-bg.182e942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-bg.jpg
// module id = 3b/Y
// module chunks = 1